const by = (states, trigger, reachable, cause) => {
    states.push(cause && !reachable ? { trigger, reachable, cause } : { trigger, reachable });
};
const isBlank = (o) => o.text.trim() === '';
/** @param options the EFFECTIVE options, roles already resolved through any matched branch. */
export function keywordReachability(d, options) {
    const states = [];
    const answerable = options.filter(o => o.role === 'correct' && !isBlank(o));
    if (d.gradingMode === 'optional') {
        by(states, 'any_response', true);
        for (const t of ['unanswered', 'correct', 'incorrect', 'any_answer'])
            by(states, t, false, 'mode');
        return { states, answerable: [] };
    }
    by(states, 'unanswered', true);
    if (d.gradingMode === 'survey') {
        by(states, 'any_answer', true);
        for (const t of ['correct', 'incorrect', 'any_response'])
            by(states, t, false, 'mode');
        return { states, answerable: [] };
    }
    by(states, 'any_answer', false, 'mode');
    by(states, 'any_response', false, 'mode');
    // A blank correct keyword cannot be typed into: the empty submission is caught as unanswered
    // first, and every non-empty string fails to equal ''. So Correct needs a keyword with text.
    by(states, 'correct', answerable.length > 0, answerable.length > 0 ? undefined : 'no-correct-option');
    const byId = new Map(options.map(o => [o.id, o]));
    for (const s of d.feedback.states) {
        if (s.type !== 'targeted' || !s.trigger.startsWith('option_'))
            continue;
        const opt = byId.get(s.trigger.slice('option_'.length));
        // Same two ways to be dead: aimed at a correct keyword, which returns before targeted runs, or
        // aimed at a blank one, which nothing can type.
        const ok = !!opt && opt.role !== 'correct' && !isBlank(opt);
        by(states, s.trigger, ok, ok ? undefined : 'no-correct-option');
    }
    // ALWAYS reachable in graded mode, and this is the rule that separates Keyword from the
    // list-based blocks. However many keywords are listed and however completely they are covered by
    // targeted feedback, a student can type something that is not any of them — which is precisely
    // what the test bar means by "Any Unlisted Word".
    by(states, 'incorrect', true);
    return { states, answerable };
}
//# sourceMappingURL=keyword-reachability.js.map